import React from 'react';
import Icon, { IconProps } from '../Icon';

const IconBoldCall: React.FC<IconProps> = ({ ...props }) => {
  const fill = props.fill || '#262626';
  return (
    <Icon {...props}>
      <path
        d="M18.857 16.607c0 0.482-0.214 1.42-0.415 1.862-0.281 0.656-1.031 1.085-1.634 1.42-0.79 0.429-1.594 0.683-2.491 0.683-1.246 0-2.371-0.509-3.509-0.924-0.817-0.295-1.607-0.656-2.344-1.112-2.277-1.406-5.022-4.152-6.429-6.429-0.455-0.737-0.817-1.527-1.112-2.344-0.415-1.138-0.924-2.263-0.924-3.509 0-0.897 0.254-1.701 0.683-2.491 0.335-0.603 0.763-1.353 1.42-1.634 0.442-0.201 1.379-0.415 1.862-0.415 0.094 0 0.188 0 0.281 0.040 0.281 0.094 0.576 0.75 0.71 1.018 0.429 0.763 0.844 1.54 1.286 2.29 0.214 0.348 0.616 0.777 0.616 1.192 0 0.817-2.424 2.009-2.424 2.732 0 0.362 0.335 0.83 0.522 1.152 1.353 2.438 3.040 4.125 5.478 5.478 0.321 0.188 0.79 0.522 1.152 0.522 0.723 0 1.915-2.424 2.732-2.424 0.415 0 0.844 0.402 1.192 0.616 0.75 0.442 1.527 0.857 2.29 1.286 0.268 0.134 0.924 0.429 1.018 0.71 0.040 0.094 0.040 0.188 0.040 0.281z"
        fill={fill}
      />
    </Icon>
  );
};

export default IconBoldCall;
